/**
 * Gescrollt wird nicht das Fenster, sondern der Inhaltsbereich des Layouts (`.main-body`) – so
 * können Seiten wie Karte und Potenziale die volle Höhe ausfüllen. Mitlaufende Tabellenköpfe
 * (sticky) funktionieren trotzdem, solange zwischen Tabelle und dieser Fläche kein weiterer
 * Scroll-Container liegt. Ohne Layout (z. B. im Test) ist es das Fenster.
 */
export const scrollflaeche = (): HTMLElement | null => document.querySelector<HTMLElement>('.main-body');
